import { useQuery } from '@apollo/client'
import { Link } from 'react-router-dom'

import { Box, Flex, Heading, Image, Text } from 'rebass/styled-components'
import { GET_COLLECTION_BY_HANDLE } from '../../graphql/queries'
import { fmtImageSize } from '../../utils'
import HandleAdd from '../HandleAdd'
import OverflowText from '../OverflowText'
import PlusBtn from '../PlusBtn'
import Price from '../Price'
import Divider from '../Divider'
import { IonIcon } from '@ionic/react'
// import { chevronForwardOutline } from 'ionicons/icons'

export default ({ title, handle }) => {
    const { data } = useQuery(GET_COLLECTION_BY_HANDLE, {
        variables: {
            handle,
        },
    })
    return (
        <Box mb="10px">
            <Divider></Divider>
            <Flex
                mb="10px"
                px="10px"
                py="5px"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    borderBottom: '1px solid #eee',
                }}
            >
                <Heading as="h3" fontSize="16px">
                    {title[0]?.text}
                </Heading>

                <Text color="#999" fontSize="14px" as={Link} to={`/promotion/${handle}`}>
                    查看更多
                </Text>
            </Flex>
            <Flex
                px="10px"
                css={{
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    '::-webkit-scrollbar': {
                        display: 'none',
                    },
                }}
            >
                {data?.collectionByHandle?.products?.edges?.map(({ node }, i) => (
                    <Flex flex="none" mr="20px" width="130px" key={i} flexDirection="column">
                        <Link to={`/detail/${node.handle}`}>
                            <Image
                                src={fmtImageSize(node?.images?.edges[0].node.src, 130)}
                                mx="auto"
                            ></Image>
                        </Link>
                        <Box height="36px">
                            <OverflowText mt="5px">{node.title}</OverflowText>
                        </Box>
                        <Flex width="100%" mt="10px" justifyContent="space-between">
                            <Price>{node?.variants?.edges[0].node.price}</Price>
                            <HandleAdd variantId={node?.variants?.edges[0].node.id}>
                                <PlusBtn size="26px"></PlusBtn>
                            </HandleAdd>
                        </Flex>
                    </Flex>
                ))}
            </Flex>
        </Box>
    )
}
